module.exports = __webpack_public_path__ + "static/M-f178291b6871e94b46ef78d3d7ad170c.png";